import gql from 'graphql-tag';

export const updateWeighingMutation = gql`
mutation updateWeighingOfCompanyEmployeeRoleTarget($updateWeighingOfCompanyEmployeeRoleTarget: UpdateWeighingOfCompanyEmployeeRoleTarget!){
    updateWeighingOfCompanyEmployeeRoleTarget(updateWeighingOfCompanyEmployeeRoleTarget: $updateWeighingOfCompanyEmployeeRoleTarget)
}`;
